module.exports = __webpack_public_path__ + "static/img/2016.2efa8a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2016.png
// module id = EmMm
// module chunks = 1